import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import BrandMark from "../BrandMark";

const links = [
  { label: "Services", to: "/services" },
  { label: "Website service", to: "/templates" },
  { label: "About", to: "/about" },
  { label: "Pricing", to: "/pricing" },
];

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setIsOpen(false), [location.pathname, location.hash]);

  return (
    <header className={`site-header${location.pathname === "/" ? " site-header-home" : ""}`}>
      <nav className="nav-shell" aria-label="Primary navigation">
        <Link className="brand" to="/" aria-label="CMJ Software home">
          <BrandMark />
          <span className="brand-name">
            CMJ <span>Software</span>
          </span>
        </Link>

        <button
          className="nav-toggle"
          type="button"
          aria-label={isOpen ? "Close navigation" : "Open navigation"}
          aria-expanded={isOpen}
          aria-controls="primary-links"
          onClick={() => setIsOpen((open) => !open)}
        >
          {isOpen ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 6l12 12M18 6 6 18" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 7h16M4 12h16M4 17h16" />
            </svg>
          )}
        </button>

        <div id="primary-links" className={`nav-links${isOpen ? " is-open" : ""}`}>
          {links.map((link) => (
            <Link
              key={link.to}
              className="nav-link"
              to={link.to}
              aria-current={location.pathname === link.to ? "page" : undefined}
            >
              {link.label}
            </Link>
          ))}
          <Link className="nav-cta" to="/#contact">
            Start a project
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default Navigation;
